export function Spinner({ label = "Loading…" }: { readonly label?: string }) {
  return (
    <span
      role="status"
      aria-live="polite"
      className="inline-flex items-center gap-2 text-sm text-ink-muted"
    >
      <span
        aria-hidden="true"
        className="block h-3 w-3 animate-spin rounded-full border-2 border-line-strong border-t-primary"
      />
      <span>{label}</span>
    </span>
  );
}
